import { Component } from "@angular/core";
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { AppServices } from 'app/servicelayer/app-services';
import { NotificationService } from "../../../common/clientSerivces/notification.service";

@Component({
    selector: 'app-password-reset-request',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, RouterModule],
    templateUrl: './reset-password-request.component.html'
})
export class ResetPasswordReqComponent
{
    showBtn: boolean = true;
    form: FormGroup;
    isReset: boolean = false;
    public get authService() { return this.appServices.authenticationService; }

    constructor(private appServices: AppServices,
        private router: Router,
        public notificationService: NotificationService,
        private location: Location,
        private formBuilder: FormBuilder)
    {
        this.form = this.formBuilder.group({
            userName: ['', Validators.required]
        });
    }

    reset()
    {
        this.authService.resetPasswordReq(this.form.value).subscribe((response: any) =>
        {
            if (response.code == 401)
            {
                this.notificationService.showError('Unexpected error', '');
            }
            else
            {
                this.isReset = true;
            }
        });
    }

    get getFormControls() { return this.form.controls; }
}